import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useEffect, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { ObjectAutocomplete } from "@hostingbv/lib/src/components/form/Autocomplete";
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";

export const MoveToCustomerModal: FC<{ currentCustomer: Customer, save: (customer: Customer) => Promise<void> }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const refresh = useRefresh()
  const [selected, setSelected] = useState<Customer>(props.currentCustomer)
  const [customers, setCustomers] = useState<Customer[]>([])
  useEffect(() => {
    partnerClient.getAllCustomers()
      .then((response) => response.success ? response.data : [])
      .then(customers => setCustomers(customers))
  }, [])


  const save = async () => {
    await props.save(selected)
    refresh()
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <ObjectAutocomplete label={"Customer"} options={customers} value={selected} onChange={setSelected} displayItem={i => i.displayName} idProperty={'id'} />
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
